// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__MjwCH","rotator":"spinner_rotator__bB0l5","path":"spinner_path__Crrqh","dash":"spinner_dash__kxJQE"};